import React from 'react';
import logo from '../assets/rsr-logo.png';

// RSR International brand mark, cropped from the official artwork.
// Single source of truth for the logo shown in every page header.
export default function Logo({ height = 30, style = {} }) {
  return (
    <img
      src={logo}
      alt="RSR International"
      style={{ height, width: 'auto', display: 'block', ...style }}
    />
  );
}
